import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Search, ChevronRight } from 'lucide-react';

const Sidebar = () => {
  const [searchQuery, setSearchQuery] = useState('');
  const navigate = useNavigate();

  const handleSearch = (e) => {
    e.preventDefault();
    if (searchQuery.trim()) {
      navigate(`/search?q=${encodeURIComponent(searchQuery)}`);
    }
  };

  const puzzleLinks = [
    {
      name: 'Pocket Grids',
      path: '/todays-pocket-grids-clues-answers',
      logo: '/pocket-grids-logo.png',
      colorClass: 'bg-blue-50 hover:bg-blue-100 border-blue-200 text-blue-800',
      iconBg: 'bg-white',
    },
    {
      name: 'Syllo',
      path: '/todays-syllo-clues-answers',
      logo: '/Syllo-logo.png',
      colorClass: 'bg-orange-50 hover:bg-orange-100 border-orange-200 text-orange-800',
      iconBg: 'bg-white',
    },
    {
      name: 'Hot and Cold',
      path: '/todays-hot-and-cold-clues-answers',
      logo: '/hotandcold-logo.png',
      colorClass: 'bg-gray-50 hover:bg-gray-200 border-gray-300 text-gray-900',
      iconBg: 'bg-white',
    },
    {
      name: 'Byrdle',
      path: '/todays-byrdle-clues-answers',
      logo: '/byrdle-logo.png',
      colorClass: 'bg-green-50 hover:bg-green-100 border-green-200 text-green-800',
      iconBg: 'bg-white',
    },
    {
      name: 'DailyGuess Solver',
      path: '/daily-guess-solver',
      logo: '/dailyguess-logo.png',
      colorClass: 'bg-yellow-50 hover:bg-yellow-100 border-yellow-200 text-yellow-800',
      iconBg: 'bg-white',
    }
  ];

  return (
    <aside className="w-full flex flex-col gap-6">
      {/* Search Bar */}
      <div className="bg-white rounded-2xl p-5 border border-gray-200 shadow-sm">
        <h3 className="text-lg font-black text-gray-900 mb-3">Search Hints</h3>
        <form onSubmit={handleSearch} className="relative">
          <input
            type="text"
            placeholder="Search puzzles..."
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            className="w-full pl-10 pr-4 py-3 bg-gray-50 border border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-brand-blue focus:border-transparent transition-all"
          />
          <Search className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400 w-5 h-5" />
        </form>
      </div>

      {/* Ad Placeholder */}
      <div className="flex items-center justify-center text-center">
        <div className="content_hint w-full h-full"></div>
      </div>

      {/* Puzzle Links */}
      <div className="bg-white rounded-2xl p-5 border border-gray-200 shadow-sm">
        <h3 className="text-lg font-black text-gray-900 mb-4">More Puzzles</h3>
        <div className="flex flex-col gap-3">
          {puzzleLinks.map((puzzle) => (
            <Link
              key={puzzle.name}
              to={puzzle.path}
              className={`flex items-center justify-between p-3 rounded-xl border transition-all duration-200 group ${puzzle.colorClass}`}
            >
              <div className="flex items-center gap-3">
                <div className={`w-10 h-10 rounded-lg flex items-center justify-center shadow-sm overflow-hidden ${puzzle.iconBg}`}>
                  <img 
                    src={process.env.PUBLIC_URL + puzzle.logo} 
                    alt={`${puzzle.name} logo`} 
                    className="w-8 h-8 object-contain"
                  />
                </div>
                <span className="font-bold">{puzzle.name}</span>
              </div>
              <ChevronRight className="w-5 h-5 opacity-50 group-hover:opacity-100 group-hover:translate-x-1 transition-all" />
            </Link>
          ))}
        </div>
      </div>
      
      {/* Second Ad Placeholder */}
      <div className="flex items-center justify-center text-center mt-2">
        <div className="content_hint w-full h-full"></div>
      </div>
    </aside>
  );
};

export default Sidebar;